export const mockPath = (url: string, mock: boolean): string => {
  const isLocal = import.meta.env.VITE_MODE === 'test';

  if (mock && isLocal) {
    const normalizedUrl = url.startsWith('/') ? url : `/${url}`;

    return `http://localhost:3333${normalizedUrl}`;
  }

  return url;
};
